<template>
  <div class="panel granary-panel">
    <div class="content-box">
      <div
        class="list-item flex"
        :class="{ active: active === index }"
        v-for="(item, index) in scList"
        :key="index"
        @click="changeType(index)"
      >
        <!-- <div class="icon-bg">
          <img :src="item.icon" alt="" />
        </div> -->
        <div>
          <div class="name">{{ item.name }}</div>
          <div class="total-box hybl-bg">
            <span class="num">{{ item.num }}</span>

            <span class="unit">{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-box">
      <div ref="scpChart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
import { loadCircleChart } from "./charts/circleChart";
export default {
  data() {
    return {
      timer: null,
      scList: [
        {
          name: "渔业（水产品）",
          icon: require("@/assets/images/granary/yy/hybl-icon.png"),
          num: 1032333,
          data: [],
          unit: "万元"
        },
        {
          name: "渔业工业及建筑业",
          icon: require("@/assets/images/granary/yy/hsyz-icon.png"),
          num: 397683,
          data: [],
          unit: "万元"
        },
        {
          name: "渔业流通和服务业",
          icon: require("@/assets/images/granary/yy/dsyz-icon.png"),
          num: 998524.91,
          data: [],
          unit: "万元"
        }
      ],
      active: 0,
      scpChart: null,
      gyChart: null,
      fwyChart: null,
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight //实时屏幕高度
    };
  },
  mounted() {
    console.log("width", this.windowWidth, this.windowHeight);
    this.scpChart = this.$echarts.init(this.$refs.scpChart);
    window.addEventListener("resize", () => {
      this.scpChart.resize();
    });
    this.getData();
  },
  methods: {
    changeType(index) {
      this.active = index;
      this.refEc();
    },
    getData() {
      this.loadScpData();
      // this.loadGyData();
      // this.loadFwyData();

      this.timer = setInterval(() => {
        if (this.active === 2) {
          this.active = 0;
        } else {
          this.active++;
        }
        this.refEc();
      }, 10000);
    },
    refEc() {
      // 更新ec
      const fontSizes = 13;
      const widths = 10;
      const itemGaps = this.active === 0 ? 15 : 8;
      let circleData = this.scList[this.active].data;
      console.log(circleData, fontSizes, widths, itemGaps);
      loadCircleChart(this.scpChart, circleData, fontSizes, widths, itemGaps);
    },
    loadScpData() {
      this.scList.forEach(e => {
        e.num = 0;
        e.data = [];
      });
      get("/api/dp/visual/queryList?code=yyjj").then(res => {
        console.log("res", res);
        const iname = "yy_item";
        const ivalue = "yy_value";
        const { data } = res;
        if (Array.isArray(data) && data.length > 0) {
          data.forEach(e => {
            const index = findIndexByName(e.series, this.scList, "name");
            if (~index) {
              this.scList[index].data.push({
                name: e[iname],
                value: Number(e[ivalue])
              });
              this.scList[index].num += Number(e[ivalue]);
            }
          });
          console.log("new data =", this.scList);
          this.refEc();
        }
      });

      // const fontSizes = 13;
      // const widths = 10;
      // const itemGaps = 15;
      // let circleData = [
      //   {
      //     name: "海洋捕捞",
      //     value: 296589
      //   },
      //   {
      //     name: "海水养殖",
      //     value: 453564
      //   },
      //   {
      //     name: "淡水捕捞",
      //     value: 2242
      //   },
      //   {
      //     name: "淡水养殖",
      //     value: 279938
      //   },
      //   {
      //     name: "水产苗种",
      //     value: 25041.68
      //   }
      // ];
      // loadCircleChart(this.scpChart, circleData, fontSizes, widths, itemGaps);
    }
    /* loadGyData() {
      this.gyChart = this.$echarts.init(this.$refs.gyChart);

      const fontSizes = 12;
      const widths = 10;
      let itemGaps = 10;
      if (this.windowHeight < 800) {
        itemGaps = 8;
      }
      let circleData = [
        {
          name: "水产品加工",
          value: 360323
        },
        {
          name: "渔业机具制造",
          value: 17445
        },
        {
          name: "渔船渔机修造",
          value: 12678
        },
        {
          name: "渔用绳网制造",
          value: 3683
        },
        {
          name: "渔用饲料",
          value: 13160
        },
        {
          name: "渔用药物",
          value: 0
        },
        {
          name: "建筑",
          value: 5255
        },
        {
          name: "其它",
          value: 1500
        }
      ];
      loadCircleChart(
        this.gyChart,
        circleData,
        fontSizes,
        widths,
        itemGaps,
        "7%"
      );

      window.addEventListener("resize", () => {
        this.gyChart.resize();
      });

      // const data = {
      //   year: this.year === "全部" ? "" : this.year,
      //   city: this.city === "广东省" ? "" : this.city,
      //   type: this.flm === "全部" ? "" : this.flm
      // };

      // getTop10(data).then(res => {
      //   // console.log("top10", res);
      //   if (res) {
      //     let slist = [];
      //     let line = [];
      //     res.forEach(ele => {
      //       slist.push(ele.name);
      //       line.push(Number(ele.num));
      //     });
      //     loadChart(this.chart, slist, line);
      //     window.addEventListener("resize", () => {
      //       setTimeout(() => {
      //         this.chart.resize();
      //       }, 300);
      //     });
      //   }
      // });
    },
    loadFwyData() {
      this.fwyChart = this.$echarts.init(this.$refs.fwyChart);

      const fontSizes = 13;
      const widths = 10;
      const itemGaps = 15;
      let right = "5%";
      if (this.windowHeight > 800) {
        right = "3%";
      }
      let circleData = [
        {
          name: "水产流通",
          value: 956525.16
        },
        {
          name: "水产(仓储)运输",
          value: 4070
        },
        {
          name: "休闲渔业",
          value: 37869.75
        },
        {
          name: "其它",
          value: 60
        }
      ];
      loadCircleChart(
        this.fwyChart,
        circleData,
        fontSizes,
        widths,
        itemGaps,
        right
      );

      window.addEventListener("resize", () => {
        this.fwyChart.resize();
      });

      // const data = {
      //   year: this.year === "全部" ? "" : this.year,
      //   city: this.city === "广东省" ? "" : this.city,
      //   type: this.flm === "全部" ? "" : this.flm
      // };

      // getTop10(data).then(res => {
      //   // console.log("top10", res);
      //   if (res) {
      //     let slist = [];
      //     let line = [];
      //     res.forEach(ele => {
      //       slist.push(ele.name);
      //       line.push(Number(ele.num));
      //     });
      //     loadChart(this.chart, slist, line);
      //     window.addEventListener("resize", () => {
      //       setTimeout(() => {
      //         this.chart.resize();
      //       }, 300);
      //     });
      //   }
      // });
    } */
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  position relative
  .chart-box
    width 100%
    height calc(100% - 70px)
  .content-box
    height 70px
    display flex
    justify-content space-around
    align-items center
    .list-item
      // padding 2px
      padding 2px 15px
      cursor pointer
      border 1px solid transparent
      transition 2s /*代表持续时间为2s，延迟时间为默认值0s*/
    .list-item.active
      border 1px solid #484848
      border-radius 999px
      background-color rgba(5,14,0,.2)
      .name
        color #f3d013
    .list-item .icon-bg
      width 50px
      height 50px
      margin-right 10px
      background url('~images/granary/yy/scp-bg.png') no-repeat
      background-size 100% 100%
      >img
        width 100%
        height 100%
    .list-item:nth-child(1)
      .total-box
        height 30px
        line-height 30px
        text-align center
        // margin-bottom 10px
        color #40d0ff
        // background url('~images/granary/yy/hybl-bg.png') no-repeat
        background-size 100% 100%

        .num
          font-size 24px
          font-family 'electronicFont'

        .unit
          font-size 14px

      .name
        font-size 14px
        // text-align center


    .list-item:nth-child(2)
      .total-box
        height 30px
        line-height 30px
        text-align center
        // margin-bottom 10px
        color #35ffec
        // background url('~images/granary/yy/hsyz-bg.png') no-repeat
        background-size 100% 100%

        .num
          font-size 24px
          font-family 'electronicFont'

        .unit
          font-size 14px

      .name
        font-size 14px
        // text-align center

    .list-item:nth-child(3)
      .total-box
        height 30px
        line-height 30px
        text-align center
        // margin-bottom 10px
        color #d59612
        // background url('~images/granary/yy/dsyz-bg.png') no-repeat
        background-size 100% 100%

        .num
          font-size 24px
          font-family 'electronicFont'

        .unit
          font-size 14px

      .name
        font-size 14px
        // text-align center

.show
  opacity 1
  left 0
</style>
